// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z4koc","colMin":"styles_colMin__3HMSQ"};